import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import React from 'react';

type CustomDatePickerProps = {
  width?: string;
  required?: boolean;
  title: string;
  error?: any;
  background?: string;
  height?: string | number;
  fontSize?: string | number;
  borderRadius?: string | number;
} & DatePickerProps;
const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  width,
  required,
  title,
  error,
  background,
  disabled,
  height,
  fontSize,
  borderRadius,
  ...props
}) => {
  dayjs().weekday(-7);
  dayjs.extend(updateLocale);
  dayjs.updateLocale('en', {
    weekStart: 1,
  });

  return (
    <div
      style={{
        width: width,
        border: disabled
          ? 'none'
          : error
            ? '0.5px solid red'
            : '0.5px solid #407FDD',
        height: height ? height : '60px',
        borderRadius: borderRadius || '10px',
        padding: '8px 16px',
        background: disabled ? '#E4E4E4' : (background ? background : 'white'),
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          flex: 1,
        }}
      >
        {height === '50px' ? (
          <div>
            <div
              style={{
                display: 'flex',
                gap: 3,
                marginBottom: -3,
                marginTop: 4,
              }}
            >
              <span
                style={{
                  color: '#898989',
                  fontWeight: 400,
                  fontSize: 10,
                  marginTop: 2,
                  lineHeight: fontSize && '12px',
                  display: 'block',
                }}
              >
                {title}
              </span>
              {required && (
                <span
                  style={{
                    color: '#ed2024',
                    fontSize: 10,
                    fontWeight: 400,
                  }}
                >
                  *
                </span>
              )}
            </div>

            <div className="custom_DatePicker">
              <DatePicker
                // locale={locale}
                style={{
                  width: '100%',
                  // height: 60,
                  padding: 0,
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  pointerEvents: disabled ? 'none' : 'auto',
                  fontSize: 12,
                }}
                allowClear={false}
                format={'YYYY - MM - DD'}
                inputReadOnly
                size={!fontSize ? 'large' : 'middle'}
                suffixIcon={null}
                bordered={false}
                placeholder=" "
                {...props}
              />
            </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: 'flex',
                gap: 2,
              }}
            >
              <span
                style={{
                  color: '#898989',
                  fontWeight: 400,
                  fontSize: 10,
                  lineHeight: fontSize && '12px',
                  display: 'block',
                }}
              >
                {title}
              </span>
              {required && (
                <span
                  style={{ color: '#ed2024', fontSize: 10, fontWeight: 400 }}
                >
                  *
                </span>
              )}
            </div>

            <DatePicker
              // locale={locale}
              style={{
                width: '100%',
                // height: 60,
                padding: 0,
                cursor: disabled ? 'not-allowed' : 'pointer',
                pointerEvents: disabled ? 'none' : 'auto',
                fontSize: 12,
              }}
              allowClear={false}
              format={'YYYY - MM - DD'}
              inputReadOnly
              size={!fontSize ? 'large' : 'middle'}
              suffixIcon={null}
              bordered={false}
              placeholder=" "
              {...props}
            />
          </div>
        )}
      </div>
      {!disabled && <img src="/icons/calendar.svg" alt="icon" />}
    </div>
  );
};

export default CustomDatePicker;
